import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTheme } from "@mui/styles";

import { useLocation } from "react-router";
import { setTitle } from "app/store/transmission/slice/transmissionSlice";
import NonCompliantPatientsTable from "components/pages/nonCompliantPatients/NonCompliantPatientsTable";
import UnenrollPatientModal from "components/pages/nonCompliantPatients/modal/UnenrollPatientModal";

import PatientModal from "components/pages/transmissions/modal/patient/PatientModal";
import NonCompliantPatientTabs from "components/pages/nonCompliantPatients/tabs/NonCompliantPatientTabs";
import NonEnrolledPatientsTable from "components/pages/nonCompliantPatients/NonEnrolledPatientsTable";
import EnrollPatientModal from "components/pages/nonCompliantPatients/modal/EnrollPatientModal";
import { useGetDeviceListQuery } from "app/store/devices/deviceApi";
import LiveCallTasks from "pages/liveCallTasks/LiveCallTasks";

const nonCompliantTabComponentMapping = {
  "no-show-patients": <NonCompliantPatientsTable />,
  "no-show-patients/non-enrolled-patients": <NonEnrolledPatientsTable />,
  "no-show-patients/live-call-tasks": <LiveCallTasks />,
};

const NonCompliantPatients = () => {
  const dispatch = useDispatch();
  const theme = useTheme();

  const { data: devices } = useGetDeviceListQuery();

  const { pathname } = useLocation();
  const path = pathname.replace("/", "");
  const selectedTab = path;

  const { isPatientModal } = useSelector((state) => state.transmission);
  const { showUnenrollModal, showEnrollModal } = useSelector(
    (state) => state.nonCompliantPatient
  );

  useEffect(() => {
    dispatch(
      setTitle({
        title: "No Show Patients",
      })
    );
  }, []);

  const tabStyles = (currentTab) => {
    return {
      border: selectedTab === currentTab ? "1px solid #E0E0E0" : "none",
      borderBottom:
        selectedTab === currentTab ? theme.palette.background.paper : "none",
      backgroundColor:
        selectedTab === currentTab
          ? theme.palette.background.paper
          : "transparent",
    };
  };

  return (
    <>
      <NonCompliantPatientTabs
        selectedTab={selectedTab}
        tabStyles={tabStyles}
      />

      {nonCompliantTabComponentMapping[selectedTab]}

      {isPatientModal && <PatientModal />}
      {showUnenrollModal && <UnenrollPatientModal />}
      {showEnrollModal && <EnrollPatientModal devices={devices} />}
    </>
  );
};

export default NonCompliantPatients;
